import { Injectable, } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ZHttpService } from './http.service';
import { ToasterService } from 'angular2-toaster';
import { NbSpinnerService } from '@nebular/theme';

@Injectable()
export abstract class BaseApiService {
    constructor(
        protected zHttp: ZHttpService,
        protected router: Router,
        protected toasterService: ToasterService,
        private spinnerService: NbSpinnerService) { }

    protected suspendSpinner: Boolean = false;

    get<T>(url: string): Observable<T> {
        if (!this.suspendSpinner) {
            this.spinnerService.showSpinner();
        }
        return this.zHttp.authGet<T>(url)
            .catch(err => this.handleError(err))
            .finally(() => {
                this.spinnerService.hideSpinner()
                this.suspendSpinner = false;
            });
    }

    post<T>(url: string, data: any): Observable<T> {

        this.spinnerService.showSpinner();

        return this.zHttp.authPost<T>(url, data)
            .map(res => {
                this.toasterService.pop({
                    type: 'success',
                    title: 'Success!',
                    body: 'Saved successfully!',
                });
                return res;
            })
            .catch(err => this.handleError(err))
            .finally(() => this.spinnerService.hideSpinner());
    }

    delete(url: string): Observable<boolean> {

        this.spinnerService.showSpinner();

        return this.zHttp.authDelete(url)
            .map(res => {
                this.toasterService.pop({
                    type: 'success',
                    title: 'Success!',
                    body: 'Deleted successfully!',
                });
                return res;
            })
            .catch(err => this.handleError(err))
            .finally(() => this.spinnerService.hideSpinner());
    }

    private handleError(error) {
        if (error instanceof Observable) {
            error.subscribe(e => {
                if (e.statusText) {
                    e.message = e.statusText;
                }
                this.toasterService.pop({
                    type: 'error',
                    title: 'Error!',
                    body: e.message || 'Undefined server error'
                });
                if (e.status && e.status === 401) {
                    setTimeout(() => { this.router.navigate(['auth/login']) }, 1000);
                }
            });
        }
        return Observable.throw(error || 'Server error');
    }
}



// WEBPACK FOOTER //
// ./src/app/services/base-api.service.ts